import React, { useCallback, useMemo, useState } from 'react'
import moment from 'moment'

import SVG from 'react-inlinesvg'

import arrowLeftIcon from 'assets/icons/arrow-left-calendar.svg'
import arrowRightIcon from 'assets/icons/arrow-right-calendar.svg'
import {
  CalendarToolbarContainer,
  CalendarToolbarDay,
  CalendarToolbarDayNumber,
} from './Calendar.styled'
import Button from 'components/Button/Button'

import { BsCalendar } from 'react-icons/bs'
import DatePicker from 'react-date-picker'

export type CalendarToolbarProps = {
  date: Date
  onDate: (date: Date) => void
}

const CalendarToolbar: React.FC<CalendarToolbarProps> = ({ date, onDate }) => {
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false)

  const toggleDatePicker = useCallback(() => {
    setShowDatePicker(prevState => !prevState)
  }, [])

  const handleToolbarDay = useCallback(
    (type: 'prev' | 'add') => {
      const newDate = moment(date)[type === 'add' ? 'add' : 'subtract'](
        1,
        'days'
      )

      onDate(newDate.toDate())
    },
    [date, onDate]
  )

  const handleDatePicker = useCallback(
    (datePicker: Date) => {
      const newDate = new Date(datePicker)

      onDate(newDate)
    },
    [onDate]
  )

  const formattedDate = useMemo(
    () => ({
      weekDay: moment(date).format('dddd'),
      day: moment(date).format('Do'),
      month: moment(date).format('MMMM'),
    }),
    [date]
  )

  return (
    <CalendarToolbarContainer>
      <SVG
        src={arrowLeftIcon}
        style={{ marginRight: '15px', cursor: 'pointer' }}
        onClick={() => handleToolbarDay('prev')}
      />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button
          text="Jump to date"
          variant="neutral"
          preset="ghost"
          size={'large'}
          LeftIcon={BsCalendar}
          leftIconStyle={{
            marginRight: '15px',
            color: '#3B3B3B',
            fontSize: '32px',
          }}
          onClick={toggleDatePicker}
        />
        <DatePicker
          isOpen={showDatePicker}
          onChange={handleDatePicker}
          value={date}
          clearIcon={null}
          calendarIcon={null}
        />
      </div>
      <SVG
        src={arrowRightIcon}
        style={{ marginLeft: '15px', cursor: 'pointer' }}
        onClick={() => handleToolbarDay('add')}
      />
      <div style={{ display: 'flex', justifyContent: 'center', width: '60%' }}>
        <CalendarToolbarDay>{formattedDate.weekDay}, </CalendarToolbarDay>
        <CalendarToolbarDayNumber>
          {formattedDate.month} {formattedDate.day}
          <span></span>
        </CalendarToolbarDayNumber>
      </div>
      <div style={{ display: 'flex', justifyContent: 'end', width: '15%' }}>
        <Button
          variant="primary"
          text="Jump to Today"
          size={'large'}
          onClick={() => handleDatePicker(new Date())}
        />
      </div>
    </CalendarToolbarContainer>
  )
}

export default CalendarToolbar
